import ApiService from './ApiService';

export default class ShopApi extends ApiService {
    constructor() {
        super('shops');
    }

    getAllShop(payload) {
        return this.get('', payload);
    }

    getAllShopSearchSeeding(payload) {
        return this.get('shops-search-seeding-comments', payload);
    }

    createShop(payload) {
        return this.post('', payload);
    }

    getShopInfo({ code, params }) {
        return this.get(code, params);
    }

    updateGeneralInfo({ code, payload }) {
        return this.put(`general-info/${code}`, payload);
    }

    updateShopInfo({ code, payload }) {
        return this.put(`shop-info/${code}`, payload);
    }

    updateOperationInfo({ code, payload }) {
        return this.put(`operation-info/${code}`, payload);
    }

    updateAppointmentInfo({ code, payload }) {
        return this.put(`appointment-info/${code}`, payload);
    }

    updateStatus(data) {
        const { code, payload } = data;
        return this.put(`status/${code}`, payload);
    }

    deleteShop(code) {
        return this.delete(code);
    }

    getAllShopService({ code, payload }) {
        return this.get(`shop-service/${code}`, payload);
    }

    createShopService({ code, payload }) {
        return this.post(`shop-service/${code}`, payload);
    }

    putShopService({ code, payload }) {
        return this.put(`shop-service/${code}`, payload);
    }

    deleteShopService(code) {
        return this.delete(`shop-service/${code}`);
    }
}
